import React from 'react';
import Head from 'next/head';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import Wizard from '..';
import { LocalizationContext } from '../../../hoc/Localization';
import { SettingsContext } from '../../../hoc/Settings';
import Terms from '../terms';
import SelectCategory from '../selectCategory';
import Price from '../price';
import TitleDescriptionComponent from '../titleDescription';
import UserContacts from '../userContacts';
import SelectImage from '../selectImage';
import Header from '../header';
import SchoolLocation from '../location';
import Finish from '../finish';
import Error from '../../../pages/_error';
import SelectType from '../selectType';
import Player from '../../TinyComponents/Player';
import styles from './styles.less';

const WizardPage = () => {
  const { step, notFound, loading } = React.useContext(EditorWizardContext);
  const { t } = React.useContext(LocalizationContext);
  const {
    domainSettings: { wizardVideoUrl, wizardLastStepVideoUrl },
  } = React.useContext(SettingsContext);

  const body = [
    <Terms />,
    <SelectType />,
    <SelectCategory />,
    <TitleDescriptionComponent />,
    <Price />,
    <UserContacts />,
    <SelectImage />,
    <SchoolLocation />,
    <Finish />,
  ];

  const isFinishStep = Number(step) === body.length - 1;

  if (notFound) {
    return <Error />;
  }
  function hiddenHeaderLoadingTime() {
    if (!loading) {
      return 'headerContainer';
    }
    return 'hiddenHeader';
  }

  return (
    <>
      <Head>
        <title>{`${t('meta.title.school_course.create')} | ${t('meta.title.suffix')}`}</title>
        <meta name="description" content={t('meta.description.school_course.create')} />
        <meta name="Description" content={t('meta.description.school_course.create')} />
      </Head>
      <div className={styles[hiddenHeaderLoadingTime()]}>
        <Header />
        {isFinishStep ?
          <Player
            key="player1"
            videoUrl={wizardLastStepVideoUrl}
            firstTitle={t('wizard.lastVideo.firstLine.text')}
            secondTitle={t('wizard.lastVideo.secondtLine.text')}
          /> :
          <Player
            key="player2"
            videoUrl={wizardVideoUrl}
            firstTitle={t('wizard.video.firstLine.text')}
            secondTitle={t('wizard.video.secondtLine.text')}
          />}
      </div>
      <Wizard style={{ background: 'lime' }}>
        <>{body[step]}</>
      </Wizard>
    </>
  );
};

export default WizardPage;
